<div class="sidebar-profile">
  <div class="detail-holder">
    <span class="name">{{user?.username}}</span>
    <span class="mail">{{user?.email}}</span>
  </div>
  <div class="profile-holder position-relative">
    <i class="fas fa-circle backend-channel" [ngClass]="'channel-' + currentBackendChanel"></i>
    <div class="profile-logo">
      <span>{{capitializedUserShortname}}</span>

      <div class="profile-detail-holder position-absolute bg-neutral-n3 px-15 py-20">
        <div class="d-flex align-items-center justify-content-between detail-top">
          <div class="name-email-holder">
            <span class="name">{{user?.username}}</span>
            <span class="mail">{{user?.email}}</span>
          </div>
          <div class="profile-logo"><span>{{capitializedUserShortname}}</span></div>
        </div>

        <div class="profile-settings">
          <span class="setting-title d-block">Account settings</span>
          <ul class="profile-menu-list mb-20">
            <li>
              <a [routerLink]="['/users/account']"><span class="icon-account"></span><span>
                  My account</span></a>
            </li>
            <li [hidden]="!is(['mainaccount', 'deputy'], true)">
              <a [routerLink]="['/users/subaccounts']">
                <span class="icon-subaccount"></span>
                <span>Subaccounts</span>
              </a>
            </li>
          </ul>
          <span class="setting-title d-block">More</span>
          <ul class="profile-menu-list mb-20">
            <li [hidden]="!is(['mainaccount', 'deputy', 'subaccount'], true)">
              <a [routerLink]="['/audit/logs/v2']">
                <span class="icon-logs"></span>
                <span>Logs</span></a>
            </li>
            <li>
              <a [href]="usageGuidelinesUrl" target="_blank" rel="noopener noreferrer">
                <span class="fas fa-external-link-alt" aria-hidden="true"></span>
                <span>Usage guidelines</span>
              </a>
            </li>
            <li *ngIf="shouldShowLegalDocumentsPage">
              <a class="legal-docs-link" [routerLink]="['/legal-documents']">
                <span class="icon-doc" aria-hidden="true"></span>
                <span>Legal Documents</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="detail-bottom pt-15">
          <ul class="profile-menu-list">
            <li>
              <a (click)="logout()">
                <span class="icon-log-out"></span>
                <span>Log Out</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
